<div class="container">
    <div class="d-flex align-items-center mt-3">
        <h1 mat-dialog-title>Underwriter Entry</h1>
    </div>
    <div class="row my-3">
        <div mat-dialog-content [formGroup]="form">
            <div class="d-flex flex-column">
                <mat-form-field appearance="outline" hideRequiredMarker>
                    <mat-label>Name<span class="required-input">*</span></mat-label>
                    <input matInput formControlName="name">
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <textarea matInput placeholder="Description" formControlName="description"></textarea>
                </mat-form-field>
            </div>
        </div>
        <div class="my-2 d-flex justify-content-end">
            <button mat-raised-button class="cancel-button" mat-dialog-close>
                <mat-icon>cancel</mat-icon>
                Cancel
            </button>
            <button mat-raised-button class="action-button" [disabled]="!canCreateUnderwriter()" (click)="submitUnderwriter()">
                <mat-icon>check</mat-icon>
                Submit Underwriter
            </button>
        </div>
        @if(!canCreateUnderwriter()) {
            <div class="my-3">
                <mat-action-row class="mt-4 d-flex justify-content-end">
                    <div class="d-flex justify-content-end align-items-center text-muted">
                        <span class="required-input">*</span>&nbsp;- Required
                    </div>
                </mat-action-row>
            </div>
        }
    </div>
</div>